module.exports = __webpack_public_path__ + "static/media/logo-saojoseribamar.8784d4d5.png";